const isProdHost = () => {
    const {REACT_APP_PROD_URL, REACT_APP_LEGACY_PROD_URL, REACT_APP_PS_PROD_URL} = process.env
    const escape = value => value.replace(/[/\-\\^$*+?.()|[\]{}]/g, '\\$&')
    const url = window.location.href

    return [REACT_APP_PROD_URL, REACT_APP_LEGACY_PROD_URL, REACT_APP_PS_PROD_URL]
        .filter(Boolean)
        .some(host => new RegExp(`^https?://(www\\.)?${escape(host)}/?`).test(url))
}

const PROD_BASE = 'https://vfleets2.vfleets.com.br/modules'
const DEFAULT_BASE = 'https://vfleets2.ttl.dev.br/modules'
const PORTAL_TARGET_PATH = 'portal'

export const getVfleetsModulesUrl = () => {
    const base = process.env.REACT_APP_VFLEETS_MODULES_URL
        || (isProdHost() ? PROD_BASE : DEFAULT_BASE)

    return `${base.replace(/\/+$/, '')}/${PORTAL_TARGET_PATH}`
}
